import React, { Fragment, Component } from 'react';
import {
    Datagrid,
    Filter,
    List,
    ReferenceInput,
    SelectInput,
    TextField,
} from 'react-admin';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import UserField from './UserField';
import Icon from '@material-ui/icons/Bookmark';
export const ConfigIcon = Icon;


export const ConfigFilter = props => (
    <Filter {...props}>
        <ReferenceInput
            source="CustomerId"
            reference="customer"
            sort={{ field: 'CustomerName', order: 'ASC' }}
        >
            <SelectInput optionText="CustomerName" />
        </ReferenceInput>
    </Filter>
);

class ConfigList extends Component {
    render() {
        const props = this.props;
        return (
            <Fragment>
                <List title={<ConfigTitle />}  {...props}
                      filters={<ConfigFilter />}
                      sort={{ field: 'Created', order: 'DESC' }}
                      exporter={false}
                >
                    <Datagrid rowClick="show">
                        <TextField label="Created [UTC]" source={"Created"} />
                        <TextField source={"CustomerName"} />
                        <TextField label="Description" source="CustomerConfigDescription"  />
                        <UserField label="Shared with"/>
                        <TextField label="Status" source={"CustomerConfigStatus"} />
                    </Datagrid>
                </List>
            </Fragment>
        );
    }
}



const ConfigTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>Custom Estimates - view only</span>;
};


export default connect(
    undefined,
    { push }
)(ConfigList);